var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"disable-btn ml-0 ml-sm-5 pl-9 pr-9",attrs:{"disabled":_vm.disabled,"loading":_vm.loading,"small":_vm.$vuetify.breakpoint.smAndDown,"color":"#464646","dark":"","elevation":"0","rounded":""},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }